export enum LoginType {
  MobileNumber,
  ExceedersID,
  ExternalProvider
}
export enum ProviderType {
  AD_AGENT = 'ad_agent',
  AZURE_AD = 'azure_ad',
  IDENEDI = 'idenedi',
  EMAIL_OTP = 'email_otp',
  ESP_USER_LIST = 'ext_list',
  GOOGLE = 'google',
  APPLE = 'apple',
  EXTERNAL_AUTH = 'external_auth'
}


// export const NotificationPreference = [
//   // { PreferedChannel: 'none', code: '', name: 'None' },
//   { PreferedChannel: 'App', code: '0', name: 'In-App Chat' },
//   { PreferedChannel: 'Email', code: '1', name: 'Email' },
//   { PreferedChannel: 'Sms', code: '2', name: 'SMS' },
//   { PreferedChannel: 'WhatsApp', code: '3', name: 'What’s App' },
// ]
